import { Fragment, useState, useEffect } from 'react';
import Paginator from 'react-hooks-paginator';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getSortedProducts } from '../../helpers/product';
import SEO from '../../components/seo';
import LayoutOne from '../../layouts/LayoutOne';
import Breadcrumb from '../../wrappers/breadcrumb/Breadcrumb';
import ShopSidebar from '../../wrappers/product/ShopSidebar';
import ShopTopbar from '../../wrappers/product/ShopTopbar';
import ShopProducts from '../../wrappers/product/ShopProducts';
import {
  getClientProductCatagory,
  getClientProducts,
  getProductCategoryRollups,
  productSelector,
} from '../../store/slices/product-slice';
import {
  authSelector,
  setSelectedCategories,
} from '../../store/slices/auth-slice';
import { Spinner } from 'react-bootstrap';

const Products = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {t} =  useTranslation();
  const { pathname, search } = useLocation();
  const query = new URLSearchParams(search);
  const seasonalCategoryId = query?.get('category');
  const { selectedCategories } = useSelector(authSelector);
  const { isLoading } = useSelector(productSelector);
  const [layout, setLayout] = useState('grid three-column');
  const [sortType, setSortType] = useState('');
  const [sortValue, setSortValue] = useState('');
  const [filterSortType, setFilterSortType] = useState('');
  const [filterSortValue, setFilterSortValue] = useState('');
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState([]);
  const [sortedProducts, setSortedProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [categories, setCategories] = useState([]);

  const pageLimit = 9;

  const getLayout = (layout) => {
    setLayout(layout);
  };

  const getSortParams = (sortType, sortValue) => {
    setSortType(sortType);
    setSortValue(sortValue);
  };

  const getFilterSortParams = (sortType, sortValue) => {
    setFilterSortType(sortType);
    setFilterSortValue(sortValue);
  };

  useEffect(() => {
    fetchProducts(currentPage, pageLimit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, selectedCategories]);

  useEffect(() => {
    dispatch(
      getProductCategoryRollups({
        parentProductCategoryId: seasonalCategoryId || '',
        setCategoryRollups: setCategories,
      })
    );
  }, []);

  useEffect(() => {
    if (!seasonalCategoryId) {
      navigate('/categories');
    }

    return () => {
      console.log('Unmount');
      dispatch(setSelectedCategories([]));
    };
  }, [pathname, seasonalCategoryId]);

  const fetchProducts = (viewIndex, viewSize) => {
    dispatch(
      getClientProducts({
        setProducts,
        seasonalCategoryId,
        setTotalRecords,
        viewIndex: viewIndex - 1,
        viewSize,
      })
    );
  };

  //   useEffect(() => {
  //     let sortedProducts = getSortedProducts(products, sortType, sortValue);
  //     const filterSortedProducts = getSortedProducts(
  //       sortedProducts,
  //       filterSortType,
  //       filterSortValue
  //     );
  //     sortedProducts = filterSortedProducts;
  //     setSortedProducts(sortedProducts);
  //     setCurrentData(sortedProducts.slice(offset, offset + pageLimit));
  //   }, [offset, products, sortType, sortValue, filterSortType, filterSortValue]);

  return (
    <Fragment>
      <SEO titleTemplate={t("Products")} description={t("Products page.")} />

      <LayoutOne headerTop="visible">
        {/* breadcrumb */}
        <Breadcrumb
          pages={[
            { label: t('Home'), path: process.env.PUBLIC_URL + '/' },
            { label: t('Products'), path: process.env.PUBLIC_URL + pathname },
          ]}
        />

        <div className="shop-area pt-95 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 order-2 order-lg-1">
                {/* shop sidebar */}
                <ShopSidebar
                  categories={categories}
                  products={[]}
                  getSortParams={getSortParams}
                  sideSpaceClass="mr-30"
                />
              </div>
              <div className="col-lg-9 order-1 order-lg-2">
                {isLoading ? (
                  <div
                    style={{
                      textAlign: 'center',
                      padding: '20px',
                      minHeight: '100vh',
                    }}
                  >
                    <Spinner animation="border" />
                  </div>
                ) : (
                  <>
                    <ShopTopbar
                      getLayout={getLayout}
                      getFilterSortParams={getFilterSortParams}
                      productCount={totalRecords}
                      sortedProductCount={products.length}
                    />

                    {/* shop page content default */}
                    <ShopProducts layout={layout} products={products} />

                    {/* shop product pagination */}
                    <div className="pro-pagination-style text-center mt-30">
                      <Paginator
                        totalRecords={totalRecords}
                        pageLimit={pageLimit}
                        pageNeighbours={2}
                        setOffset={setOffset}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        pageContainerClass="mb-0 mt-0"
                        pagePrevText="«"
                        pageNextText="»"
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

export default Products;
